import { z } from 'zod/v4';

import { endpoint } from '../http/endpoint';
import {
    OfferImportContextCreationDTORuntype,
    OfferImportContextDTORuntype,
    OfferImportContextUpdateDTORuntype,
} from './offerImportContextBackendTypes';

export const offerImportContextEndpoints = {
    'GET /offer-import-contexts': endpoint({
        description: 'Retrieve a list of offer import contexts',
        pathParams: z.undefined(),
        queryParams: z.undefined(),
        requestBody: z.undefined(),
        responseBody: z.object({
            items: z.array(OfferImportContextDTORuntype),
        }),
    }),
    'POST /offer-import-contexts': endpoint({
        description: 'Create a new offer import context',
        pathParams: z.undefined(),
        queryParams: z.undefined(),
        requestBody: OfferImportContextCreationDTORuntype,
        responseBody: OfferImportContextDTORuntype,
        invalidates: ['GET /offer-import-contexts', 'GET /offer-import-contexts/:id'],
    }),
    'GET /offer-import-contexts/:id': endpoint({
        description: 'Retrieve a single offer import context',
        pathParams: z.object({
            id: z.string().uuid(),
        }),
        queryParams: z.undefined(),
        requestBody: z.undefined(),
        responseBody: OfferImportContextDTORuntype,
    }),
    'PATCH /offer-import-contexts/:id': endpoint({
        description: 'Edit an offer import context',
        pathParams: z.object({
            id: z.string().uuid(),
        }),
        queryParams: z.undefined(),
        requestBody: OfferImportContextUpdateDTORuntype,
        responseBody: OfferImportContextDTORuntype,
        invalidates: ['GET /offer-import-contexts', 'GET /offer-import-contexts/:id'],
    }),
    'DELETE /offer-import-contexts/:id': endpoint({
        description:
            'Delete an offer import context. `linked_offers` says what happens to its offers: `reject` (the default) ' +
            'refuses while it has offers, `delete` deletes them unless a sourcing line item selects one, and ' +
            '`force_delete` deletes them all and resets the affected sourcing line items to pending.',
        pathParams: z.object({
            id: z.string().uuid(),
        }),
        queryParams: z.object({ linked_offers: z.enum(['reject', 'delete', 'force_delete']).optional() }),
        requestBody: z.undefined(),
        responseBody: z.object({ deleted_ids: z.array(z.string().uuid()), deleted_offer_ids: z.array(z.string()) }),
        invalidates: ['GET /offer-import-contexts', 'GET /offer-import-contexts/:id'],
    }),
};
